<template>
  <div>
    <b-list-group>
      <b-list-group-item
        v-for='(flatPage, i) in flatpages'
        :key='flatPage.id'
      >
        
          {{flatPage.title.pl}} [{{flatPage.title.en}}]
        
        <div class='float-right'>
          <b-button-group size='sm'>

            <b-button
              variant='info'
              @click='() => actions.handleClickMoveUpFlatPage(flatPage.id)'
              :disabled='i === 0'
            ><b-icon-caret-up-fill /></b-button>

            <b-button
              variant='success'
              @click='() => actions.handleClickMoveDownFlatPage(flatPage.id)'
              :disabled='i === flatpages.length - 1'
            ><b-icon-caret-down-fill /></b-button>

          </b-button-group>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>  

<script>
  import {
    BIconCaretUpFill,
    BIconCaretDownFill,
  } from 'bootstrap-vue'
  import {
    handleClickMoveUpFlatPage,
    handleClickMoveDownFlatPage,
  } from '@/store/utils.js'

  export default {
    components: {
      BIconCaretUpFill,
      BIconCaretDownFill,
    },
    data() {
      return {
        actions: {
          handleClickMoveUpFlatPage,
          handleClickMoveDownFlatPage,
        },
      }
    },
    computed: {
      form() {
        return this.$store.state.fanzones.form
      },
      flatpages() {
        if (this.form.doc.flatPages && this.form.doc.flatPages.length > 0) {
          return this.form.doc.flatPages
        }

        return []
      },
    },
  }

</script>
